import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {catchError, retry} from "rxjs/operators";
import {Task} from "@components/my-web-desk/new-task-modal/task.service";
import {environment} from "@env/environment";
import {BehaviorSubject, Observable, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BacklogService {
    private apiURL = environment.apiURL;
    public sprintCreated = new BehaviorSubject<any>(false);


    constructor(private http: HttpClient
    ) {
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            return of(result as T);
        };
    }

    getData(projectId) {
        const params = new HttpParams()
            .set('project_id', projectId);
        return this.http.get<Task[]>(this.apiURL + '/backlog/getBacklogTasks', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getData')));
    }

    getActiveSprints(projectId) {
        const params = new HttpParams()
            .set('project_id', projectId);
        return this.http.get<Task[]>(this.apiURL + '/backlog/getSprints', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getActiveSprints')));
    }

    getTaskData(id, sort) {
        const params = new HttpParams()
            .set('taskId', id)
            .set('sort', sort);
        return this.http.get(this.apiURL + '/task/get',
            {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getTaskData')));

    }


    moveTask(taskId, location) {
        const params = new HttpParams()
            .set('id', taskId)
            .set('location', location);
        return this.http.post(this.apiURL + '/backlog/moveTask', params).pipe(
            retry(1),
            catchError(this.handleError<any>('moveTask')));

    }

    createNewSprint(projectId) {
        const params = new HttpParams().set('project_id', projectId);
        return this.http.post(this.apiURL + '/backlog/createNewSprint',
            params)
            .pipe(
                retry(1),
                catchError(this.handleError('createNewSprint')));
    }

    activateSprint(sprintId) {
        const params = new HttpParams().set('sprint_id', sprintId);

        return this.http.post(this.apiURL + '/backlog/activateSprint', params)
            .pipe(
                retry(1),
                catchError(this.handleError('activateSprint')));
    }

    setStoryPoints(taskId: string, storyPoints: number, sort: string) {
        const params = new HttpParams().set('task_id', taskId)
            .set('sort', sort)
            .set('story_points', storyPoints.toString());

        return this.http.post(this.apiURL + '/backlog/setStoryPoints', params)
            .pipe(
                retry(1),
                catchError(this.handleError('setStoryPoints')));
    }

    setSprint(taskId: string, sprintId: string) {
        const params = new HttpParams().set('taskId', taskId).set('sprintId', sprintId);
        return this.http.post(this.apiURL + '/backlog/setSprintForTask', params)
            .pipe(
                retry(1),
                catchError(this.handleError('setSprint')));
    }

    getActiveAndInactiveSprints(projectId) {
        const params = new HttpParams()
            .set('project_id', projectId);
        return this.http.get(this.apiURL + '/backlog/getActiveAndInactiveSprints', {params}).pipe(
            retry(1),
            catchError(this.handleError<any>('getActiveAndInactiveSprints')));
    }

    removeSprint(taskId) {
        const params = new HttpParams()
            .set('taskId', taskId);
        return this.http.post(this.apiURL + '/backlog/removeSprintForTask', params).pipe(
            retry(1),
            catchError(this.handleError<any>('removeSprintForTask')));
    }


}
